export default __webpack_public_path__ + "static/media/Restart.f29a22cb.svg";